import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';

import Intervention from "../../../services/Intervention";
import TiresAndWheelsServices from "./TiresAndWheelsServices";
import AppointmentServicesCard from "./AppointmentServicesCard";

class ServicesCardWrapper extends Component {

  render() {
    const {intervention, canWrite} = this.props;
    return (
      <div>
        {Intervention.isTypeTiresAndWheels(intervention) &&
            <TiresAndWheelsServices canWrite={canWrite} intervention={intervention}/>
        }
        {Intervention.isTypeAppointment(intervention) &&
            <AppointmentServicesCard canWrite={canWrite} />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ServicesCardWrapper))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/services/ServicesCardWrapper.js